import React from 'react';
import './Footer.css';
const Footer = () => {

    return (
        <>
            <footer className="main-footer">
                © 2026 Solifi. All rights reserved.
            </footer>
        </>
    )
}
export default Footer